import { render, staticRenderFns } from "./ComponentDemoPage.vue?vue&type=template&id=bdc8ef78&scoped=true&"
import script from "./ComponentDemoPage.vue?vue&type=script&lang=ts&"
export * from "./ComponentDemoPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc8ef78",
  null
  
)

export default component.exports